// @flow
import styled from '@emotion/styled'
import transparentize from 'polished/lib/color/transparentize'
import * as React from 'react'

import { colors, media, variables } from '@toggl/style'

import * as text from '../text'

export const Wrapper = ({
  children,
  className,
}: React.ElementProps<typeof WrapperRoot>): React.Element<
  typeof WrapperRoot
> => <WrapperRoot className={className}>{children}</WrapperRoot>

const WrapperRoot = styled<{
  className?: string,
  children: $ReadOnlyArray<React.Element<typeof Link>>,
}>('div')`
  display: none;
  flex-direction: row;
  width: 100%;
  height: 50px;
  background-color: ${colors.almostWhite};
  position: sticky;
  top: ${variables.headerHeightTablet - 1}px;
  z-index: 999;
  ${media.mq[1]} {
    display: flex;
  }
  ${media.mq[2]} {
    top: ${variables.headerHeightFull - 1}px;
  }
`

type LinkProps = {|
  +active?: boolean,
  +children: React.Node,
  +className?: string,
  +onClick: () => void,
|}

export function Link({ active, children, className, onClick }: LinkProps) {
  const onLinkClick = (e) => {
    e.preventDefault()
    onClick()
  }

  return (
    <LinkRoot active={active} className={className} onClick={onLinkClick}>
      <Title active={active}>{children}</Title>
    </LinkRoot>
  )
}

const LinkRoot: React.ComponentType<any> = styled.a`
  flex: 1 auto;
  cursor: pointer;

  background-color: ${({ active }) => (active ? colors.darkPurple : '')};
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${({ active }) => (active ? 'default' : 'pointer')};

  &:not(:last-child) {
    border-right: 1px solid ${transparentize(0.9, colors.fadedPurpleAlt)};
  }

  &:hover {
    div {
      ${({ active, theme }) =>
        active ? '' : `border-bottom: 1px solid ${theme.primary}`}
    }
  }
`

const Title: React.ComponentType<any> = styled.div`
  ${text.paragraph3};
  color: ${({ active }) => (active ? colors.almostWhite : colors.darkPurple)};
  padding-bottom: 4px;
`
